var audio = {

    // One toast per page, however many players run into the same lost session.
    unauthorizedNotified: false,

    init: (id, dotnet) => {
        let player = helper.element("#player-" + id, false);
        let track = helper.element("#track-" + id, false);
        let waveform = helper.element("#waveform-" + id, false);
        let btnplay = helper.element("#btnplay-" + id, false);
        let btnpause = helper.element("#btnpause-" + id, false);

        if (player && track && waveform && btnplay && btnpause) {

            // A media element never exposes the HTTP status of a failed load, so ask the
            // endpoint again: a 401 means the media session is gone and only a new login helps.
            let checked = false;
            let checkUnauthorized = () => {
                if (checked)
                    return;
                checked = true;

                let source = player.querySelector("source");
                fetch(source ? source.src : player.currentSrc, { headers: { Range: "bytes=0-0" } })
                    .then((response) => {
                        if (response.status !== 401)
                            return;

                        let toast = !audio.unauthorizedNotified;
                        audio.unauthorizedNotified = true;
                        dotnet.invokeMethodAsync("OnUnauthorized", toast);
                    })
                    .catch(() => {});
            };

            // The <source> reports a failed load, the player a failure during playback (a range
            // request). The load may already have failed before init ran.
            let source = player.querySelector("source");
            if (source)
                helper.event(source, "error", checkUnauthorized);
            helper.event(player, "error", checkUnauthorized);
            if (player.networkState === HTMLMediaElement.NETWORK_NO_SOURCE)
                checkUnauthorized();

            helper.event(player, "timeupdate", (e) => {
                let progress = (player.currentTime / player.duration) * 100;
                track.style.width = `${progress}%`;
            });

            helper.event(player, "ended", (e) => {
                player.currentTime = 0;
                btnplay.style.display = "block";
                btnpause.style.display = "none";
            });

            helper.event(waveform, "click", (e) => {
                e.preventDefault();
                let rect = waveform.parentElement.getBoundingClientRect();
                let clickX = e.clientX - rect.left;
                let percentage = clickX / rect.width;
                // No duration (yet) when the audio failed or has not loaded; seeking would throw.
                if (isFinite(player.duration))
                    player.currentTime = percentage * player.duration;
            });

            btnplay.style.display = "block";
            btnpause.style.display = "none";
            helper.event(btnplay, "click", (e) => {
                e.preventDefault();
                player.play();
                btnplay.style.display = "none";
                btnpause.style.display = "block";
            });

            helper.event(btnpause, "click", (e) => {
                e.preventDefault();
                player.pause();
                btnplay.style.display = "block";
                btnpause.style.display = "none";
            });
        }
    }
};